import { render, staticRenderFns } from "./fj.vue?vue&type=template&id=19ad657a&scoped=true&"
import script from "./fj.vue?vue&type=script&lang=js&"
export * from "./fj.vue?vue&type=script&lang=js&"
import style0 from "./fj.vue?vue&type=style&index=0&id=19ad657a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ad657a",
  null
  
)

export default component.exports